import ReactDOM from "react-dom";
import React from "react";
import registerServiceWorker from "./registerServiceWorker";
import App from "./App";
import { routes } from "./routes";
import { generateRoutes } from "./helpers/routing";
import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap.bundle';

class Root extends React.Component {
  constructor(props) {
    super(props);
    this.state = {currentModal: null}
  }

  componentDidMount() {
    if(document.cookie.indexOf("USER_DATA") > -1 && !localStorage.logged){
      let name = JSON.parse(decodeURIComponent(document.cookie.split("USER_DATA=")[1]).split(";")[0])["ep.first_name"];
      localStorage.logged = true;
      localStorage.username = name;
      location.reload();
    }
  }

  actionsModal(action, modalName) {
    return (e) => {
      if(action == "open"){
        e.preventDefault();
        if (e.currentTarget.href) {
          let urlModal = e.currentTarget.href.split("?")[1];
          window.history.pushState("", "", "?"+urlModal);
        }
        this.setState({currentModal: modalName});
      }else{
        this.setState({currentModal: null});
        window.document.querySelector("body").style.overflow = 'auto';
      }
    }
  }

  render () {
    const { Router, Switch, Route } = this.props;
    return (
      <App {...this.props} currentModal={this.state.currentModal} actionsModal={this.actionsModal.bind(this)}>
        <Router basename={process.env.BASE_URL}>{generateRoutes(routes, Switch, Route, {
          ...this.props,
          actionsModal: this.actionsModal.bind(this)
        })}</Router>
      </App>
    );
  }
}

//TODO: FIND A BETTER WAY OF HANDLING THIS IMPORTS.
import(`./assets/sass/brands/${process.env.BRAND_INITIALS}_style.useable.scss`)
  .then(style => style.use())
  .then(() => {
    process.env.REDUX
      ? import("./store").then(store => {
          import("react-router-dom/BrowserRouter").then(BrowserRouter => {
            import("react-router-dom/Switch").then(Switch => {
              import("react-router-dom/Route").then(Route => {
                ReactDOM.render(
                  <store.default>
                    {Root(BrowserRouter.default, Switch.default, Route.default)}
                  </store.default>,
                  document.getElementById("root")
                );
              });
            });
          });
        })
      : import("react-router-dom/BrowserRouter").then(BrowserRouter => {
          import("react-router-dom/Switch").then(Switch => {
            import("react-router-dom/Route").then(Route => {
              ReactDOM.render(
                <Root Router={BrowserRouter.default} Switch={Switch.default} Route={Route.default} />,
                document.getElementById("root")
              );
            });
          });
        });
    registerServiceWorker();
  });



// WEBPACK FOOTER //
// ./src/index.js